import { render, staticRenderFns } from "./SoaCard.vue?vue&type=template&id=6fcf26ca&lang=pug"
import script from "./SoaCard.vue?vue&type=script&lang=js"
export * from "./SoaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports